export const dfilogo = () => {

    return (
    <svg width='1.5em' height='1.5em' viewBox='0 0 32 32'>
      <circle cx={16} cy={16} r={16} fill='#FF00AF' />
      <path
        fill='#FFF'
        d='M18.217 23.454V8.546c3.21.958 5.555 3.937 5.555 7.454s-2.346 6.496-5.555 7.454M15.994 6v8.428l-1.269-1.27-.162-3.167 1.324-3.985a9.952 9.952 0 00-2.454.338l-.64 1.926-1.816-.91a10.03 10.03 0 00-1.974 1.497l3.363 1.685.098 1.928-1.927-.099L8.85 9.01a10.035 10.035 0 00-1.497 1.973l.911 1.816-1.927.64A9.978 9.978 0 006 15.892l3.986-1.324 3.168.162 1.27 1.27-1.27 1.27-3.168.162L6 16.108c.009.849.13 1.669.338 2.454l1.927.64-.911 1.816c.418.719.92 1.383 1.497 1.973l1.686-3.362 1.927-.099-.098 1.928-3.363 1.685a10.04 10.04 0 001.974 1.498l1.815-.911.64 1.926a9.94 9.94 0 002.455.338l-1.324-3.985.162-3.168 1.27-1.27V26c5.522 0 10-4.477 10-10s-4.478-10-10-10'
      />
    </svg>
    )
}

export const btclogo = () => {
    return (
      <svg width='1.5em' height='1.5em' viewBox='0 0 32 32'>
        <path
          fill='#F7931A'
          d='M31.521 19.87c-2.137 8.572-10.82 13.788-19.393 11.651C3.558 29.384-1.659 20.702.479 12.131 2.616 3.56 11.298-1.659 19.87.48c8.573 2.137 13.79 10.82 11.652 19.392z'
        />
        <path
          fill='#FFF'
          d='M22.96 14.04c.313-2.101-1.276-3.23-3.448-3.985l.705-2.846-1.72-.432-.686 2.772a67.899 67.899 0 00-1.379-.327l.691-2.79L15.404 6l-.705 2.846a57.2 57.2 0 01-1.099-.26l.002-.01-2.372-.596-.458 1.85s1.277.296 1.25.314c.696.175.822.64.801 1.008l-.802 3.243c.048.012.11.03.179.057l-.182-.045-1.125 4.543c-.085.213-.302.533-.789.412.018.025-1.25-.315-1.25-.315L8 21.031l2.239.562c.416.105.824.215 1.226.319l-.712 2.88 1.718.431.706-2.849c.469.129.925.247 1.37.359l-.702 2.835 1.72.432.712-2.874c2.934.56 5.14.334 6.068-2.339.748-2.152-.037-3.393-1.58-4.202 1.123-.261 1.97-1.006 2.196-2.545zm-4.012 5.8c-.497 1.961-3.858.901-4.948.635L14.883 17c1.09.267 4.584.796 4.065 2.84zm.991-6.05c-.538 1.993-3.861.98-4.939.732L15.95 11c1.079.248 4.55.712 3.99 2.79z'
        />
      </svg>
    )
}

export const dusdlogo = () => {
  return (
    <svg height='1.5em' width='1.5em' viewBox='0 0 32 32'>
      <path
        d='M32 15.9908C32 24.8268 24.836 31.9908 16 31.9908C7.164 31.9908 0 24.8268 0 15.9908C0 7.15484 7.164 -0.00915527 16 -0.00915527C24.836 -0.00915527 32 7.15484 32 15.9908Z'
        fill='#FFCCEF'
      />
      <path
        d='M15.9704 3.6842L18.5494 4.37527L17.2958 9.05185L21.9734 10.3059L21.2823 12.885L15.8448 11.4272L14.017 12.4833C13.3798 12.8508 13.1617 13.6645 13.5304 14.3025C13.8979 14.9397 14.7116 15.1577 15.3496 14.7891C17.2638 13.685 19.7107 14.3408 20.8157 16.2545C21.8841 18.1067 21.3047 20.4576 19.532 21.6104L19.3508 21.7216L17.2928 22.9092L15.8783 28.1912L13.2992 27.5002L14.5098 22.9758L9.98877 21.7659L10.6792 19.1867L15.9548 20.5982L18.0149 19.4099C18.6522 19.0412 18.8706 18.2261 18.5032 17.5891C18.1357 16.9526 17.3211 16.7343 16.6846 17.1014C14.77 18.2077 12.3222 17.5517 11.2181 15.6374C10.1474 13.7846 10.7273 11.4325 12.5011 10.2817L12.6825 10.1707L14.5158 9.1112L15.9704 3.6842Z'
        fill='#FF00AF'
      />
    </svg>
  )
}    
